export const setupOnboarding = {
  piezas: {
    confirmacion: { etiqueta: "Bestätigung", larga: "Buchungsbestätigung", porque: "Es wird Ihre kontoweite Einstellung verwendet, nicht eine für diese Unterkunft." },
    bienvenida: { etiqueta: "Willkommen", larga: "Willkommensnachricht", porque: "Derzeit geht die Standard-Willkommensnachricht raus, und sie ist nicht Ihre." },
    checkin: { etiqueta: "Check-in", larga: "Check-in-Versand", porque: "Derzeit geht er zur Standardzeit raus, die Ihnen vielleicht nicht passt." },
    horas: { etiqueta: "Zeiten", larga: "Check-in- und Check-out-Zeiten", porque: "Ohne Ihre Zeiten erhalten Gäste auf Nachfrage die Standardzeiten." },
    cerradura: { etiqueta: "Zugang", larga: "Schloss und Zugang", porque: "Ihr Gast steht vor der Tür und weiß nicht, wie er sie öffnet." },
    servicios: { etiqueta: "Leistungen", larga: "Leistungen der Unterkunft", porque: "Weder die Buchungsmaschine noch der Agent weiß, was Sie anbieten." },
    politicas: { etiqueta: "Regeln", larga: "Richtlinien und Regeln", porque: "Ihr Gast stimmt Standardregeln zu, nicht Ihren." },
  },
  titular: {
    listo: "Alles ist bereit",
    unoAMedias: "Ihre Unterkunft ist halb eingerichtet",
    variosAMedias: "Ihre Unterkünfte sind halb eingerichtet",
    casi: "Sie sind fast fertig",
  },
  consecuencia: {
    bienvenida: "In der Zwischenzeit erhalten Ihre Gäste die Standard-Willkommensnachricht, die nicht Ihre ist.",
    cerradura: "In der Zwischenzeit stünden manche Gäste vor der Tür, ohne zu wissen, wie sie sie öffnen.",
    politicas: "In der Zwischenzeit stimmen Ihre Gäste Standardregeln zu, nicht Ihren.",
    generico: "In der Zwischenzeit werden die Standardeinstellungen verwendet, nicht Ihre.",
  },
  explicacion: {
    listoUno: "Ihre Unterkunft kann jetzt Gäste empfangen.",
    listoVarios: "Ihre {n} Unterkünfte können jetzt Gäste empfangen.",
    ajustesFinos: "Die Feinheiten wie Preise, Kanäle und Erlebnisse warten in jedem Inserat auf Sie, wann immer Sie möchten.",
    faltaUno: "Noch 1 Unterkunft fertigstellen.",
    faltanVarios: "Noch {n} Unterkünfte fertigstellen.",
  },
  resumen: {
    unAlojamiento: "1 Unterkunft",
    nAlojamientos: "{n} Unterkünfte",
    unoPorPreparar: "1 einzurichten",
    nPorPreparar: "{n} einzurichten",
    listos: "{listos} bereit",
  },
  anillo: {
    rotulo: "eingerichtet",
    ariaCorta: "{n}% eingerichtet",
    ariaLarga: "{n}% der Einrichtung abgeschlossen",
  },
  cifras: {
    listos: "bereit ·",
    ajustes: "Einstellungen erledigt",
    ariaAjustes: "{hechas} von {total} Einstellungen erledigt",
    marcador: "{hechas} von {total}",
  },
  ventana: {
    titulo: "Diesen Hinweis schließen?",
    texto: "Er erscheint dann nicht mehr im Panel, auch wenn noch etwas nicht eingerichtet ist.",
    notaAntes: "Sie können ihn jederzeit zurückholen über",
    notaRuta: "Anpassen → Einrichtungshinweis anzeigen",
    cancelar: "Abbrechen",
    ocultar: "Schließen",
  },
  acciones: {
    verQueFalta: "Ansehen, was fehlt",
    buscar: "Unterkunft suchen",
    sinResultados: "Keine ausstehende Unterkunft heißt so.",
    verClaro: "Zu Hell wechseln",
    verOscuro: "Zu Dunkel wechseln",
    ampliar: "Vergrößern",
    ampliarAria: "Hinweis vergrößern",
    minimizar: "Minimieren",
    minimizarAria: "Hinweis minimieren",
    entendido: "Verstanden",
    entendidoAria: "Verstanden, Hinweis schließen",
    ocultar: "Schließen",
    ocultarAria: "Einrichtungshinweis schließen",
    empezar: "Starten",
    continuar: "Fortfahren",
    hecho: "erledigt",
    teToca: "Als Nächstes:",
    unidades: "{n} Einheiten",
  },
};
